export const LOAD_ANNUAL_FINALS = "LOAD_ANNUAL_FINALS";
export const LOAD_ANNUAL_FINALS_SUCCESS = "LOAD_ANNUAL_FINALS_SUCCESS";
export const LOAD_ANNUAL_FINALS_FAILED = "LOAD_ANNUAL_FINALS_FAILED";
